import { BehaviorSubject } from "rxjs";

import {
  authHeader,
  authLogin,
  getHeader,
  handleLoginResponse,
} from "@/helpers";
import jwt_decode from "jwt-decode";

import { authLoginURL } from "../api";

const currentUserSubject = new BehaviorSubject(
  JSON.parse(localStorage.getItem("currentUser"))
);
const currentUserToken = new BehaviorSubject(
  JSON.parse(localStorage.getItem("refreshToken"))
);

export const authenticationService = {
  login,
  logout,
  currentUser: currentUserSubject.asObservable(),
  currentUserToken: currentUserToken.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  },
  get currentUserToken() {
    // console.log("currentUserToken",currentUserToken.value)
    return currentUserToken.value;
  },
};

function login(userDa) {
  const userData = {
    usercode: userDa["usercode"],
    password: userDa["password"],
  };
  const requestOption = {
    method: "POST",
    headers: authLogin(),
    body: JSON.stringify(userData),
  };
  const URL = authLoginURL();

  return fetch(URL, requestOption)
    .then(handleLoginResponse)
    .then((response) => {
      if (response["responseStatus"] == 200) {
        let decoded = jwt_decode(response["responseObject"]["access_token"]);
        let refreshToken = jwt_decode(
          response["responseObject"]["refresh_token"]
        );
        decoded["token"] = response["responseObject"]["access_token"];
        if (response.data) {
          let permissionJson = JSON.parse(response.data);
          decoded["permissionJson"] = JSON.stringify(permissionJson);
        }
        decoded["status"] = response["responseStatus"];

        localStorage.setItem("currentUser", JSON.stringify(decoded));
        localStorage.setItem(
          "refreshTokenOrg",
          response["responseObject"]["refresh_token"]
        );
        localStorage.setItem("refreshToken", JSON.stringify(refreshToken));

        currentUserSubject.next(decoded);
        currentUserToken.next(response);
        return decoded;
      } else {
        return response;
      }
    });
}

function logout() {
  localStorage.clear();
  currentUserSubject.next(null);
}
